import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-8 animate-fade-in">
      <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
      <p className="text-xl text-muted-foreground mb-6">העמוד לא נמצא</p>
      <Link 
        to="/" 
        className="flex items-center gap-2 px-6 py-3 rounded-xl gradient-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
      >
        <span>חזרה לדף הבית</span>
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default NotFound;
